import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const SoundOnIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5.001,1.442 3.089865,3.65169 H 1.000975 V 6.3036 h 1.77778 L 5.001,8.51355 Z" />
            <path d="m 5.890625,1.0449219 v 0.9277343 c 2.8629076,0.9817494 3.0131271,4.8866596 0,5.9199219 v 0.9296875 c 4.099983,-0.9173879 4.1040098,-6.8590549 0,-7.7773437 z" />
            <path d="m 5.8945312,3.2089844 c -0.00288,2.4676206 0.00391,-0.037037 0.00391,3.6191406 1.4965873,-0.6943715 1.4920342,-2.9249208 -0.00391,-3.6191406 z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const SoundOnIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5.001,1.442 3.089865,3.65169 H 1.000975 V 6.3036 h 1.77778 L 5.001,8.51355 Z" />
            <path d="m 5.890625,1.0449219 v 0.9277343 c 2.8629076,0.9817494 3.0131271,4.8866596 0,5.9199219 v 0.9296875 c 4.099983,-0.9173879 4.1040098,-6.8590549 0,-7.7773437 z" />
            <path d="m 5.8945312,3.2089844 c -0.00288,2.4676206 0.00391,-0.037037 0.00391,3.6191406 1.4965873,-0.6943715 1.4920342,-2.9249208 -0.00391,-3.6191406 z" />
        </SvgIcon>
    );
};
